import { call, put, select, takeLatest } from "redux-saga/effects";
import { FETCH_KEY_CONVERSATION_REQUEST, fetchKeyConversationFailure, fetchKeyConversationSuccess } from "../actions/keyConversationActions";
import { fetchKeyConversations } from "../../../services/accIqService";
import { fetchRecentConversations } from "../../../services/iqApiV2";


// Worker Saga
function* fetchKeyConversationSaga() {
  try {
    const payload = yield select(state=>state?.keyConversationReducer?.payload);
    const {accountName} = payload;
    const data = yield call(fetchRecentConversations,accountName);
    yield put(fetchKeyConversationSuccess(data));
  } catch (error) {
    yield put(fetchKeyConversationFailure(error.message));
  }
}

// Watcher Saga
export function* watchFetchKeyConversation() {
  yield takeLatest(FETCH_KEY_CONVERSATION_REQUEST, fetchKeyConversationSaga);
}
